import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showModal } from '@store/actions/commonAction';
import { certiSmsUpdCp } from '@store/actions/userAction';

import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import MobileAgent from '@components/login/MobileAgent';
import { MobileTermsAgree } from '@container/customer';

const AuthMobileAgent = () => {
  const [mobileTelNo, setMobileTelNo] = useState('');
  const [agent, setAgent] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();
  const [showMobiletermsAgree, setShowMobiletermsAgree] = useState(false);
  const handleCertSms = () => {
    if (mobileTelNo === '' || agent === '') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '입력 정보가 없는 항목이 있습니다.\n 입력 정보를 다시 확인해주세요.',
        }),
      );
      return false;
    } else {
      // TODO API call
      // sms 인증
      dispatch(certiSmsUpdCp({ mobileTelNo, mobileCorp: agent, reqType: 'T' }));
      // history.push({
      //   pathname: '/login/verifyAuthMobileAgent',
      //   state: { mobileTelNo: mobileTelNo },
      // });
    }
  };

  return (
    <>
      <SatModal visible={showMobiletermsAgree} type="fullPop">
        <MobileTermsAgree
          agentType={agent}
          onClose={() => setShowMobiletermsAgree(false)}
        />
      </SatModal>

      <div className="login-area">
        <div className="page-navi">
          <span onClick={() => history.goBack()} className="btn-back">
            이전
          </span>
        </div>
        <h3 className="tit-con">동의를 위한 본인 인증</h3>
        <p className="text-con">본인 명의의 휴대폰 정보를 입력해 주세요.</p>
        <MobileAgent
          mobileTelNo={mobileTelNo}
          setMobileTelNo={setMobileTelNo}
          agent={agent}
          setAgent={agent => setAgent(agent.value)}
        />
        <div className="agree-list modal-type">
          <div className="tit-area">
            <div className="check-wrap default">
              <input type="checkbox" name="checkboxAll" id="checkboxAll" />
              <label htmlFor="checkboxAll">모두 동의합니다.</label>
            </div>
            <button
              onClick={() => setShowMobiletermsAgree(true)}
              className="btn-view"
            >
              전문보기
            </button>
          </div>
          <ul className="list-block">
            <li>개인정보 수집/이용 동의</li>
            <li>고유식별정보 처리 동의</li>
            <li>서비스 이용약관 동의</li>
            <li>통신사 이용약관 동의</li>
            <li>알뜰폰 제3자 제공 동의</li>
          </ul>
        </div>
        <div className="btn-area">
          <SatButton
            label="인증번호 받기"
            styleClass="btn-l blue"
            onClick={handleCertSms}
          />
        </div>
      </div>
    </>
  );
};

export default AuthMobileAgent;
